import { differenceInMilliseconds } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
import { Adventure } from '~/components/Adventure/Adventure.hooks';
import { sharedDateTimer } from '~/components/Util/timer.hooks';

export const useAdventureStatus = (data?: Adventure) => {
  const [now, setNow] = useState(sharedDateTimer.now);
  const { startAt = now, endAt = now } = data || {};

  const statusMeta = useMemo(() => {
    const statuses: { key: Adventure['status']; remain: number }[] = [
      {
        key: 'UPCOMING',
        remain: differenceInMilliseconds(startAt, now),
      },
      {
        key: 'IN_PROGRESS',
        remain: differenceInMilliseconds(endAt, now),
      },
      {
        key: 'END',
        remain: Infinity,
      },
    ];
    return statuses.find((status) => status.remain > 0);
  }, [endAt, now, startAt]);

  useEffect(() => {
    if (!statusMeta?.remain) return;
    const timer = setTimeout(() => setNow(sharedDateTimer.now), statusMeta.remain);
    return () => clearTimeout(timer);
  }, [statusMeta?.remain]);

  return statusMeta?.key;
};
